// Root
export const ADMIN = "/admin";
export const BACKOFFICE = "/backoffice/";
export const PAYMENT_CONFIRMATION = "/payment/confirmation";
export const MODELS = "/references";
export const WORKSPACES = "/workspaces";
export const USER_ONBOARDING = "/user-onboarding";

// Workspace
export const HOME = "home";
export const BOARDS = "boards";
export const WORKSPACE_MODELS = "references";

// Workspace - Home
export const PURCHASES = "purchases";
export const HOME_PROJECTS = "projects";
export const HOME_BRAND_KIT = "brand-kit";
export const HOME_STYLES = "styles";
export const HOME_CHARACTERS = "characters";
export const HOME_OBJECTS = "objects";

// Workspace - Board - Workspaces
export const CREATE_WORKSPACE = "create";
export const EDIT_WORKSPACE = "edit";

// Workspace - Board - Tools
export const GENERATE_TOOL = "generate";
export const GENERATE_TOOL_PATH =
  `${CREATE_WORKSPACE}/${GENERATE_TOOL}` as const;

export const TRANSFER_TOOL = "transfer";
export const TRANSFER_TOOL_PATH =
  `${CREATE_WORKSPACE}/${TRANSFER_TOOL}` as const;

export const BRIEF_TOOL = "brief";
export const BRIEF_TOOL_PATH = `${CREATE_WORKSPACE}/${BRIEF_TOOL}` as const;

export const EDIT_IMAGE_WITH_PROMPT_TOOL = "edit-image-with-prompt";
export const EDIT_IMAGE_WITH_PROMPT_TOOL_PATH =
  `${EDIT_WORKSPACE}/${EDIT_IMAGE_WITH_PROMPT_TOOL}` as const;

export const VARIATION_TOOL = "variation";
export const VARIATION_TOOL_PATH =
  `${EDIT_WORKSPACE}/${VARIATION_TOOL}` as const;

export const FILL_TOOL = "fill";
export const FILL_TOOL_PATH = `${EDIT_WORKSPACE}/${FILL_TOOL}` as const;

export const UPSCALE_TOOL = "upscale";
export const UPSCALE_TOOL_PATH = `${EDIT_WORKSPACE}/${UPSCALE_TOOL}` as const;

export const EXPAND_TOOL = "expand";
export const EXPAND_TOOL_PATH = `${EDIT_WORKSPACE}/${EXPAND_TOOL}` as const;

export const EDIT_TEXT_TOOL = "edit-text";
export const EDIT_TEXT_TOOL_PATH =
  `${EDIT_WORKSPACE}/${EDIT_TEXT_TOOL}` as const;

export const EDIT_SHAPE_TOOL = "edit-shape";
export const EDIT_SHAPE_TOOL_PATH =
  `${EDIT_WORKSPACE}/${EDIT_SHAPE_TOOL}` as const;

export const EDIT_IMAGE_TOOL = "edit-image";
export const EDIT_IMAGE_TOOL_PATH =
  `${EDIT_WORKSPACE}/${EDIT_IMAGE_TOOL}` as const;

export const EDIT_ASSET_TOOL = "edit-asset";
export const EDIT_ASSET_TOOL_PATH =
  `${EDIT_WORKSPACE}/${EDIT_ASSET_TOOL}` as const;

export const ANIMATE_TOOL = "animate";
export const ANIMATE_TOOL_PATH = `${EDIT_WORKSPACE}/${ANIMATE_TOOL}` as const;

export const COPY_AD_TOOL = "copy-ad";
export const COPY_AD_TOOL_PATH = `${EDIT_WORKSPACE}/${COPY_AD_TOOL}` as const;
